import { useEffect, useState } from 'react';
import { getCurrentWebsiteContent, subscribeWebsiteContent, WebsiteContent } from '../utils/websiteContent';

export function useWebsiteContent(): WebsiteContent {
  const [content, setContent] = useState<WebsiteContent>(getCurrentWebsiteContent);

  useEffect(() => subscribeWebsiteContent(setContent), []);

  return content;
}
